import React, { useEffect, useState } from 'react';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [showFooter, setShowFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isNearBottom = windowHeight + scrollTop >= documentHeight - 100;
      setShowFooter(isNearBottom);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <main className="relative min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50" data-id="element-117">
      <Header data-id="element-118" />
      <div className="relative z-10" data-id="element-119">{children}</div>

      {/* Footer - Only visible when scrolled to bottom */}
      <footer className={`fixed bottom-0 left-0 right-0 z-20 py-6 bg-white border-t-4 border-gray-800 transition-transform duration-500 ease-out ${showFooter ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-120">
        <div className="w-full px-4" data-id="element-121">
          <div className="flex items-center justify-center" data-id="element-122">
            <p className="text-gray-600 font-medium text-sm tracking-wide" data-id="element-123">
              © 2026 HorizonIMA. All Rights Reserved.
            </p>
            <div className="ml-4 flex gap-2" data-id="element-124">
              <div className="w-3 h-3 rounded-full bg-coral-500 animate-bounce-gentle" data-id="element-125" />
              <div className="w-3 h-3 rounded-full bg-yellow-400 animate-bounce-gentle" style={{
              animationDelay: '0.1s'
            }} data-id="element-126" />
              <div className="w-3 h-3 rounded-full bg-purple-400 animate-bounce-gentle" style={{
              animationDelay: '0.2s'
            }} data-id="element-127" />
            </div>
          </div>
        </div>
      </footer>
    </main>;
}